module.exports = __webpack_public_path__ + "img/logo.27bd24d3.png";